import { IconButton, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";

const styles = {
  closeBtn: {
    position: "absolute",
    right: 12,
    top: 12,
    color: "rgba(0, 0, 0, 0.54)",
  },
};

export default function UnsavedChangesDialog({ show, close, onDiscard }: any) {
  return (
    <Dialog
      open={show}
      onClose={close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" fontWeight={"510"}>
        Unsaved Changes
      </DialogTitle>
      <IconButton aria-label="close" onClick={close} sx={styles.closeBtn}>
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <Typography sx={{ mt: -1 }}>
          You have made changes to a question that have not been saved.
          Continuing will discard these changes.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button sx={{ fontWeight: "510" }} variant="contained" onClick={close}>
          Return to Editing
        </Button>
        <Button sx={{ fontWeight: "510" }} variant="text" onClick={onDiscard}>
          Discard Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
